export const colTypeNames = {
  string: "строковые данные",
  number: "числовой признак",
  enum: "качественный признак",
  boolean: "логическое значение",
};

export function colTypeToString(colType) {
  if (typeof colType === "string") return colTypeNames[colType] || colType;
  return undefined; // TODO: enums
}
